import { create } from 'zustand';

interface ProgressState {
  cpcProgress: number;
  setCpcProgress: (progress: number) => void;
}

export const useProgressStore = create<ProgressState>((set) => ({
  cpcProgress: 0,
  setCpcProgress: (progress) => set({ cpcProgress: progress }),
}));
